import { FormattedMessage } from '@umijs/max';
import { Modal } from 'antd';
import React from 'react';

type ReceiptModalProps = {
  open: boolean;
  onClose: () => void;
  className?: string;
  width?: number;
};

export const ReceiptModal: React.FC<ReceiptModalProps> = ({
  open,
  onClose,
  className,
  width = 640,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={width}
      className={className}
    >
      <div className="receipt-content">
        <div className="receipt-title">
          <FormattedMessage
            id="components.rightContent.receiptModal.title"
            defaultMessage="Thank you"
          />
        </div>
        <div className="receipt-copy">
          <FormattedMessage
            id="components.rightContent.receiptModal.description"
            defaultMessage="Your report has been submitted."
          />
        </div>
      </div>
    </Modal>
  );
};
